import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import { LinkClickedEvent } from '@atlassian/mpac-analytics';
import { AtlassianProductHostingTypeValues } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
import { ExternalLink } from '@atlassian/mpac-ui';
import { MarketplaceAppUtils } from '@atlassian/mpac-utils';
import React from 'react';
import { useScreenClass } from 'react-grid-system';
import { ANALYTICS_EVENT_CONTAINER_SITE_SELECTOR, ANALYTICS_SUBJECT_ID_CONTACT_ADMIN } from "../../../analytics/Events";
import { TEST_ID } from "../../../constants";
import { DataCenterMayWorkHostingColumn, HostingColumn } from "./HostingColumn";
import { HostingSelectorModalContent, ModalFooterInfo } from "./HostingSelectorModal.styles";
import { toAnalyticsHosting } from "./HostingSelectorModal.utils";
export default function HostingSelectorModal(props) {
  var _Object$freeze, _props$serverAppVersi;

  var _useAnalyticsEvents = useAnalyticsEvents(),
      createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;

  var appHostingMap = Object.freeze((_Object$freeze = {}, _defineProperty(_Object$freeze, AtlassianProductHostingTypeValues.Cloud, props.cloudAppVersion), _defineProperty(_Object$freeze, AtlassianProductHostingTypeValues.Server, props.serverAppVersion), _defineProperty(_Object$freeze, AtlassianProductHostingTypeValues.DataCenter, props.dataCenterAppVersion), _Object$freeze));
  var screenClass = useScreenClass();

  var onShareThisAppClick = function onShareThisAppClick() {
    // only for server and datacenter
    createAnalyticsEvent({
      eventType: LinkClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_CONTACT_ADMIN,
      attributes: {
        eventContainer: ANALYTICS_EVENT_CONTAINER_SITE_SELECTOR,
        label: 'share with admin',
        hostingSelected: toAnalyticsHosting(props.highlightedHosting)
      }
    }).fire();
  };

  var modalActions = screenClass === 'xs' ? [{
    text: 'Cancel',
    onClick: props.onClose,
    appearance: 'default'
  }] : [];
  var nonAdminRequestAppMessage = /*#__PURE__*/React.createElement(ModalFooterInfo, null, /*#__PURE__*/React.createElement("b", null, "Not an admin?"), " No problem. ", /*#__PURE__*/React.createElement("br", null), props.highlightedHosting === AtlassianProductHostingTypeValues.Cloud ? /*#__PURE__*/React.createElement(Button, {
    testId: TEST_ID.HOSTING_SELECTOR_MODAL_REQUEST_APP,
    appearance: "link",
    spacing: "none",
    onClick: props.onRequestAppClick
  }, "Request this app") : /*#__PURE__*/React.createElement(ExternalLink, {
    onClick: onShareThisAppClick,
    href: props.shareWithAdminLink
  }, "Share this app"), ' ', "with your admin and they can install it for you.");
  var productHostingOptions = Object.keys(appHostingMap).filter(function (hosting) {
    return !!appHostingMap[hosting];
  });
  var serverCompatibleProducts = ((_props$serverAppVersi = props.serverAppVersion) === null || _props$serverAppVersi === void 0 ? void 0 : _props$serverAppVersi.deployment.compatibleProducts) || [];
  var appCompatibleWithDcEnabledProduct = MarketplaceAppUtils.maybeDCCompatible(productHostingOptions, serverCompatibleProducts);
  return /*#__PURE__*/React.createElement(ModalTransition, null, props.isOpen && /*#__PURE__*/React.createElement(Modal, {
    width: "large",
    onClose: props.onClose,
    heading: "Select your hosting type",
    autoFocus: false,
    actions: modalActions
  }, /*#__PURE__*/React.createElement(HostingSelectorModalContent, null, productHostingOptions.map(function (hosting) {
    return /*#__PURE__*/React.createElement(HostingColumn, {
      key: hosting,
      appKey: props.appKey,
      appId: props.appId,
      onCTAClick: props.onCTAClick,
      licensePurchaseLink: props.licensePurchaseLink,
      privateListingsLink: props.privateListingsLink,
      artifactDownloadLink: props.artifactDownloadLink,
      privateRemotableOnly: props.privateRemotableOnly,
      trialLicenseActivationLink: props.trialLicenseActivationLink,
      isHighlighted: hosting === props.highlightedHosting // $FlowIgnore We've filtered out null values in the map using Array#filter before
      ,
      appVersion: appHostingMap[hosting],
      hosting: hosting,
      purchaseIntent: props.purchaseIntent,
      activeCTAKind: props.activeCTAKind
    });
  }), !props.dataCenterAppVersion && appCompatibleWithDcEnabledProduct && /*#__PURE__*/React.createElement(DataCenterMayWorkHostingColumn, null)), nonAdminRequestAppMessage));
}